// src/components/InjectionBanner.js
import React from 'react';
import Injectio from '../../../imgs/Injectio.webp';
import './standardinje.css';
import Reqprodcte from "../../../components/Reqprodcte";


const Standardinje = () => {
  return (
    <div className="injection-container" data-aos="fade-down">
      {/* Background Image */}
      <img
        src={Injectio}
        alt="Injection"
        className="injection-image" 
      />
      {/* Text on image */}
      <div className="injection-text">
        <h1 className="injection-heading">Injection Molding Machine</h1>
        <p className="injection-subtext">
          High-Efficiency and Reliable Injection Molding Machines to Meet Your Production Needs
        </p>
        <p className="injection-subtext">
          We offer a variety of injection molding machines with different tonnages to help you achieve your production goals.
          Whether you aim to increase production capacity or optimize your production processes, our equipment delivers practical benefits to your business.
        </p>
        <ul className="injection-list">
          <li>90～1380 Tons Toggle Injection Molding Machines</li>
          <li>650～4500 Tons Two-Plate Injection Molding Machines</li>
          <li>Up to 360 Tons All-Electric Injection Molding Machines</li>
        </ul>
        <div className='stnd'>
          <Reqprodcte />
        </div>

      </div>
    </div>
  );
};

export default Standardinje;
